import { Suspense, useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import ErrorBoundary from "../modules/admin/component/ErrorBoundary"
import { sidebarList } from "../constants/sidebarList"
import AdminSidebar from "../modules/admin/component/AdminSidebar"
import { Spinner } from "olive-react-myoneui"
import NavigationBar from "../modules/admin/component/NavigationBar"
import { setSidebarData } from "../reducers/sidebarSlice"
import { useDispatch, useSelector } from "react-redux"

function AdminLayout() {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname === "/admin" || location.pathname === "/admin/") {
      navigate("/admin/dashboard")
    }
  }, [location.pathname, navigate])

  const enableActiveWrapper = useSelector(
    (state) => state.sidebar.enableActiveWrapper
  )

  useEffect(() => {
    const actPath = sidebarList.find(
      (s) =>
        s.link === location.pathname || location.pathname.includes(`${s.link}/`)
    )
    const enableActive = actPath && (actPath.children || actPath.isDynamic)
    dispatch(setSidebarData({ enableActiveWrapper: enableActive }))
  }, [location.pathname, dispatch])

  return (
    <>
      {location.pathname !== "/admin/login" && <NavigationBar />}
      <main
        className={
          enableActiveWrapper ? "main-wrapper active-wrapper" : "main-wrapper"
        }
      >
        {location.pathname !== "/admin/login" && <AdminSidebar />}

        <ErrorBoundary>
          <Suspense fallback={<Spinner animation='border' size='sm' />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
    </>
  )
}

export default AdminLayout
